import type { CameraRenderConfig } from "../render/types.ts";

/**
 * PROVISIONAL M0 VALUES — USER TUNING REQUIRED.
 *
 * These values establish the close third-person composition for visual review.
 * They are not a final camera-feel pass.
 */
export const CAMERA_RENDER_CONFIG: CameraRenderConfig = Object.freeze({
  fovDegrees: 48,
  nearMeters: 0.08,
  farMeters: 760,
  flightFarMeters: 1_450,
  distanceMeters: 5.6,
  minDistanceMeters: 3.5,
  maxDistanceMeters: 8,
  targetHeightMeters: 1.35,
  shoulderOffsetMeters: 0.52,
  minPitchRadians: Math.PI * 0.03,
  maxPitchRadians: Math.PI * 0.31,
  initialPitchRadians: Math.PI * 0.045,
  orbitRadiansPerPixel: 0.0024,
  zoomMetersPerPixel: 0.009,
  sprintFovDegrees: 52,
  fovResponsePerSecond: 7,
  verticalFollowResponsePerSecond: 11,
  collisionRadiusMeters: 0.16,
  collisionBufferMeters: 0.08,
  obstructionFadeOpacity: 0.28,
});
